import classes from "../classes";
import detectScrollBelow from "./higher-order/detect-scroll-below";
import pure from "./higher-order/pure";
import React from "react";
import selectPage from "../select-page";
import TableHeaderNextPage from "./table-header-next-page";
import TableHeaderPreviousPage from "./table-header-previous-page";
import TablePaginationSpacer from "./table-pagination-spacer";
import TableHeaderTicket from "./table-header-ticket";
import TableHeaderTicketScore from "./table-header-ticket-score";

export default detectScrollBelow(pure(function PlayFieldHeader({ firstRace, myTickets, onNextPage, onPreviousPage, page, pageSize, scrolled, tokenTypes, tournament }) {
  var runnerLabel = "Horse";

  if (typeof firstRace !== "undefined" && firstRace.get("track_breed_type") === "Greyhound") {
    runnerLabel = "Greyhound";
  }

  return (
    <div className={classes({
      "game-table_header_placeholder": true,
      "game-table_header--is-fixed": scrolled
    })}>
      <div className="game-table_header_container">
        <h3 className="game-table_title">
          {tournament.get("name")}
        </h3>

        <p className="game-table_note visible--mobile">
          Pick a
          {" "}

          <button className="btn btn--small btn--mock tooltip tooltip--white tooltip--immediate" data-tooltip={"If your Primary " + runnerLabel + " is scratched then your Alternate will be used."} type="button">
            P
          </button>

          {" "}

          <strong>
            {"Primary " + runnerLabel}
          </strong>

          {" "}
          and an (optional)

          {" "}

          <button className="btn btn--small btn--mock tooltip tooltip--white tooltip--immediate" data-tooltip={"If your Primary and your Alternate " + runnerLabel + " is scratched then the Post Time Favorite (PTF) will be selected for you."} type="button">
            A
          </button>

          {" "}

          <strong>
            {"Alternate " + runnerLabel}
          </strong>

          {" "}
          in each race.
        </p>

        <PlayFieldHeaderFirstRow firstRace={firstRace} myTickets={myTickets} onNextPage={onNextPage} onPreviousPage={onPreviousPage} page={page} pageSize={pageSize} tokenTypes={tokenTypes} />

        <PlayFieldHeaderSecondRow myTickets={myTickets} open={tournament.get("status") === "open"} page={page} pageSize={pageSize} />
      </div>
    </div>
  );
}), 120);

var PlayFieldHeaderFirstRow = pure(function PlayFieldHeaderFirstRow({ firstRace, myTickets, onNextPage, onPreviousPage, page, pageSize, tokenTypes }) {
  var ticketCols = selectPage(myTickets, page, pageSize).map((ticket) => <TableHeaderTicket key={ticket.get("id")} ticket={ticket} tokenTypes={tokenTypes} />);
  var runnerLabel = "Horse";

  if (typeof firstRace !== "undefined" && firstRace.get("track_breed_type") === "Greyhound") {
    runnerLabel = "Greyhound";
  }

  return (
    <div className="game-table game-table--tickets">
      <div className="game-table_row game-table_row--header">
        <div className="game-table_cell">
          <p className="game-table_note hidden--mobile">
            Pick a
            {" "}

            <button className="btn btn--small btn--mock tooltip tooltip--white tooltip--immediate" data-tooltip={"If your Primary " + runnerLabel + " is scratched then your Alternate will be used."} type="button">
              P
            </button>

            {" "}

            <strong>
              {"Primary " + runnerLabel}
            </strong>

            {" "}
            and an (optional)

            {" "}

            <button className="btn btn--small btn--mock tooltip tooltip--white tooltip--immediate" data-tooltip={"If your Primary and your Alternate " + runnerLabel + " is scratched then the Post Time Favorite (PTF) will be selected for you."} type="button">
              A
            </button>

            {" "}

            <strong>
              {"Alternate " + runnerLabel}
            </strong>

            {" "}
            in each race.
          </p>
        </div>

        <TableHeaderPreviousPage onClick={onPreviousPage} page={page} pageSize={pageSize} totalItems={myTickets.count()} />

        {ticketCols}

        <TableHeaderNextPage onClick={onNextPage} page={page} pageSize={pageSize} totalItems={myTickets.count()} />
      </div>
    </div>
  );
});

var PlayFieldHeaderSecondRow = pure(function PlayFieldHeaderSecondRow({ myTickets, open, page, pageSize }) {
  var ticketScoreCols = selectPage(myTickets, page, pageSize).map((ticket) => <TableHeaderTicketScore key={ticket.get("id")} ticket={ticket} />);

  var status = "Status";
  if (!open) {
    status = (
      <div className="game-table_results-table">
        <div className="game-table_results-cell">
          Entrant
        </div>

        <div className="game-table_results-cell">
          Win
        </div>

        <div className="game-table_results-cell">
          Place
        </div>

        <div className="game-table_results-cell">
          Show
        </div>
      </div>
    );
  }
  return (
    <div className="game-table">
      <div className="game-table_row game-table_row--header">
        <div className="game-table_cell game-table_cell--action game-table_cell--race">
          Race
        </div>

        <div className="game-table_cell game-table_cell--track">
          Track
        </div>

        <div className="game-table_cell game-table_cell--overview">
          <span className="game-table_label">
            Overview
          </span>
        </div>

        <div className="game-table_cell game-table_cell--results">
          {status}
        </div>

        <TablePaginationSpacer pageSize={pageSize} totalItems={myTickets.count()} />

        {ticketScoreCols}

        <TablePaginationSpacer pageSize={pageSize} totalItems={myTickets.count()} />
      </div>
    </div>
  );
});
